export const UP_ARROW = 'ArrowUp'
export const DOWN_ARROW = 'ArrowDown'
export const LEFT_ARROW = 'ArrowLeft'
export const RIGHT_ARROW = 'ArrowRight'
export const TAB = 'Tab'
export const ENTER = 'Enter'
export const ESCAPE = 'Escape'
export const SPACE = ' '
export const BACKSPACE = 'Backspace'
export const HOME = 'Home'
export const END = 'End'
export const PAGE_UP = 'PageUp'
export const PAGE_DOWN = 'PageDown'

export function hasModifierKey(event: KeyboardEvent): boolean {
  return event.altKey || event.shiftKey || event.ctrlKey || event.metaKey
}
